import { PLAN_ICONS } from '../plan-wizard.react/constants';
import { PlanTypeEnumContract } from '../types';

export const getPlanIcon = (planType: PlanTypeEnumContract): string => {
	return PLAN_ICONS[planType] ? PLAN_ICONS[planType] : '';
};
